//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import UserInfoModule from 'app_components/modules/campus/user/userInfo'
import ActivityCalendarModule from 'app_components/modules/campus/academic/activityCalendar'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../accountExecutiveDashboardSidebarModule.scss'

// @ADD Component types
interface IAccountExecutiveDashboardSidebarModuleLayoutProps {}

const AccountExecutiveDashboardSidebarModuleLayout: React.FC<IAccountExecutiveDashboardSidebarModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='account-executive_dashboard_sidebar-component'>
      <section className="account-executive-user-info">
        <UserInfoModule showChangePassword />
      </section>
      <section className="account-executive-activity-calendar">
        <ActivityCalendarModule />
      </section>
    </div>
  )
}

export default AccountExecutiveDashboardSidebarModuleLayout
